import * as actionTypes from "../actionTypes";
import axios from "../../middleware/axios-api";
import { formatBase64Image, getErrors, getResData } from "../../shared/utility";
import { USER_TYPE } from "../../constants/constants";

// Add Product
export const addProductStart = () => {
  return {
    type: actionTypes.ADD_PRODUCT_START,
  };
};

export const addProductSuccess = (addProductRes: any) => {
  return {
    type: actionTypes.ADD_PRODUCT_SUCCESS,
    addProductRes,
  };
};

export const addProductFailed = (error: any) => {
  return {
    type: actionTypes.ADD_PRODUCT_FAIL,
    error,
    addProductRes: null,
  };
};

export const addProduct = (data: any) => {
  return async (dispatch: any) => {
    dispatch(addProductStart());

    return axios
      .post(`/seller/advert/publish`, data)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          return dispatch(addProductSuccess(data.data));
        }
      })
      .catch((err) => dispatch(addProductFailed(getErrors(err))));
  };
};

// Product Details
export const addProductDetails = (data: any) => {
  return {
    type: actionTypes.ADD_PRODUCT_DETAILS,
    productDetails: data,
  };
};

// Product Preview
const addProductPreviewStart = () => {
  return {
    type: actionTypes.ADD_PRODUCT_PREVIEW_START,
  };
}
export const addProductPreview = (productPreview: any) => {
  return async (dispatch: any ) => {
    await dispatch(addProductPreviewStart)

    return await dispatch({
      type: actionTypes.ADD_PRODUCT_PREVIEW,
      productPreview,
    })
  }
};

const addProductPreviewImagesStart = () => {
  return {
    type: actionTypes.ADD_PRODUCT_PREVIEW_IMAGES_START,
  };
}

export const addProductPreviewImages = (productPreviewImages:Array<string>) => {
  return async (dispatch: any ) => {
    await dispatch(addProductPreviewImagesStart)

    return await dispatch({
      type: actionTypes.ADD_PRODUCT_PREVIEW_IMAGES,
    productPreviewImages,
    })
  }

}

// Get Seller Product
export const getSellerProductStart = () => {
  return {
    type: actionTypes.GET_SELLER_PRODUCT_START,
  };
};

export const getSellerProductSuccess = (sellerProducts: any) => {
  return {
    type: actionTypes.GET_SELLER_PRODUCT_SUCCESS,
    sellerProducts,
  };
};

export const getSellerProductFailed = (error: any) => {
  return {
    type: actionTypes.GET_SELLER_PRODUCT_FAIL,
    error,
    sellerProducts: null,
  };
};

export const getSellerProduct = ({data, signal}: any) => {
  return async (dispatch: any) => {
    dispatch(getSellerProductStart());

    return axios
      .post(`/seller/adverts`, data, {signal})
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          return dispatch(getSellerProductSuccess(data.data));
        }
      })
      .catch((err) => dispatch(getSellerProductFailed(getErrors(err))));
  };
};

// Get Seller Product Details By ID
export const getProductDetailsStart = () => {
  return {
    type: actionTypes.GET_PRODUCT_DETAILS_START,
  };
};

export const getProductDetailsSuccess = (singleProductDetails: any) => {
  return {
    type: actionTypes.GET_PRODUCT_DETAILS_SUCCESS,
    singleProductDetails,
  };
};

export const getProductDetailsFailed = (error: any) => {
  return {
    type: actionTypes.GET_PRODUCT_DETAILS_FAIL,
    error,
    singleProductDetails: null,
  };
};

export const getProductDetails = (data: any, profile: any) => {
  const URL =`${profile?.profileType ? profile?.profileType?.toLocaleLowerCase(): ''}/advert/details`;

  return async (dispatch: any) => {
    dispatch(getProductDetailsStart());

    return axios
      .post(URL, data)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          dispatch(addProductDetails(data.data));
          // dispatch(addProductPreview(null));
          return dispatch(getProductDetailsSuccess(data.data));
        }
      })
      .catch((err) => dispatch(getProductDetailsFailed(getErrors(err))));
  };
};

// Get Single Product Images for product details page and preview product page
const getSingleProductImagesStart = () => {
  return {
    type: actionTypes.GET_SINGLE_PRODUCT_IMAGES_START,
  };
};

export const getSingleProductImagesSuccess = (singleProductImages: any) => {
    return {
      type: actionTypes.GET_SINGLE_PRODUCT_IMAGES_SUCCESS,
      singleProductImages
    };
};

const getSingleProductImagesFailed = (error: any) => {
  return {
    type: actionTypes.GET_SINGLE_PRODUCT_IMAGES_FAIL,
    error,
  };
};

export const getSingleProductImages = (advertId: number, profileType:string) => {
  const URL =`${profileType ? profileType.toLocaleLowerCase(): ''}/advert/image/load/${advertId}`;

  return (dispatch: any) => {
    dispatch(getSingleProductImagesStart());

    return axios
      .get(URL)
      .then((response) => {
        if (!response) throw new Error("No Response");
        
        let data;
        if(response.data.data){
          data = formatBase64Image(response.data.data);        
        }
        return dispatch(getSingleProductImagesSuccess({data, advertId}));
      })
      .catch((err) => dispatch(getSingleProductImagesFailed(getErrors(err))));
  };
};

// Get Buyer Product
export const getBuyerProductStart = () => {
  return {
    type: actionTypes.GET_BUYER_PRODUCT_START,
  };
};

export const getBuyerProductSuccess = (buyerProducts: any) => {
  return {
    type: actionTypes.GET_BUYER_PRODUCT_SUCCESS,
    buyerProducts,
  };
};

export const getBuyerProductFailed = (error: any) => {
  return {
    type: actionTypes.GET_BUYER_PRODUCT_FAIL,
    error,
    buyerProducts: null,
  };
};

export const getBuyerProduct = ({data, signal}: any) => {
  return async (dispatch: any) => {
    dispatch(getBuyerProductStart());

    return axios
      .post(`/buyer/adverts`, data, {signal})
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          return dispatch(getBuyerProductSuccess(data.data));
        }
      })
      .catch((err) => dispatch(getBuyerProductFailed(getErrors(err))));
  };
};

// Get Product Image
export const getProductImageStart = () => {
  return {
    type: actionTypes.GET_PRODUCT_IMAGE_START,
  };
};

export const getProductImageSuccess = (productImage: any, isLr: boolean,) => {
  return {
    type: actionTypes.GET_PRODUCT_IMAGE_SUCCESS,
    productImage,
    isLr,
  };
};

export const getProductImageFailed = (error: any) => {
  return {
    type: actionTypes.GET_PRODUCT_IMAGE_FAIL,
    error,
  };
};

export const getProductImage = (advertId: number, profileType?:string, signal?: any, isLr: boolean = false, ) => {
  /* isLr => is Low resolution */  
  /* Update the below "url" later. Currently, the seller does not have "lr". */
  const url =`${profileType ? profileType.toLocaleLowerCase(): ''}/advert/image${(isLr && profileType !== USER_TYPE.SELLER) ? '-lr' : ''}/load/${advertId}`;
  return (dispatch: any) => {
    dispatch(getProductImageStart());

    return axios
      .get(url,{signal})
      .then((response) => {
        if (!response) throw new Error("No Response");
        
        let data;
        if(response.data.data){
          data = formatBase64Image(response.data.data);        
        }
        return dispatch(getProductImageSuccess({data, advertId}, isLr,));
      })
      .catch((err) => dispatch(getProductImageFailed(getErrors(err))));
  };
};

// Get New Products  
export const getNewProductsStart = () => {
  return {
    type: actionTypes.GET_NEW_PRODUCT_START,
    newProducts: null
  };
};

export const getNewProductsSuccess = (newProducts: any) => {
  return {
    type: actionTypes.GET_NEW_PRODUCT_SUCCESS,
    newProducts
  };
};

export const getNewProductsFailed = (error: any) => {
  return {
    type: actionTypes.GET_NEW_PRODUCT_FAIL,
    error,
  };
};

export const getNewProducts = (data: any) => {
  return async (dispatch: any) => {
    dispatch(getNewProductsStart());

    return axios
      .post(`/adverts`, data)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          return dispatch(getNewProductsSuccess(data.data));
        }
      })
      .catch((err) => dispatch(getNewProductsFailed(getErrors(err))));
  };
};

// Get BestSeller Products  
export const getBestSellerProductsStart = () => {
  return {
    type: actionTypes.GET_BEST_SELLER_PRODUCT_START,
    bestSellerProduct: null
  };
};

export const getBestSellerProductsSuccess = (bestSellerProduct: any) => {
  return {
    type: actionTypes.GET_BEST_SELLER_PRODUCT_SUCCESS,
    bestSellerProduct
  };
};

export const getBestSellerProductsFailed = (error: any) => {
  return {
    type: actionTypes.GET_BEST_SELLER_PRODUCT_FAIL,
    error,
  };
};

export const getBestProducts = ({data, signal}: any) => {
  return async (dispatch: any) => {
    dispatch(getBestSellerProductsStart());

    return axios
      .post(`/adverts`, data, {signal})
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          return dispatch(getBestSellerProductsSuccess(data.data));
        }
      })
      .catch((err) => dispatch(getBestSellerProductsFailed(getErrors(err))));
  };
}

// delete Product
export const deleteProductStart = () => {
  return {
    type: actionTypes.DELETE_PRODUCT_START,
  };
};

export const deleteProductSuccess = () => {
  return {
    type: actionTypes.DELETE_PRODUCT_SUCCESS,
  };
};

export const deleteProductFailed = (error: any) => {
  return {
    type: actionTypes.DELETE_PRODUCT_FAIL,
    error,
  };
};

export const deleteProduct = (data: any) => {
  return async (dispatch: any) => {
    dispatch(deleteProductStart());

    return axios
      .post(`/seller/advert/delete`, data)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          return dispatch(deleteProductSuccess());
        }
      })
      .catch((err) => dispatch(deleteProductFailed(getErrors(err))));
  };
};

// Edit Product
const editProductStart = () => {
  return {
    type: actionTypes.EDIT_PRODUCT_START,
  };
};

const editProductSuccess = (addProductRes: any) => {
  return {
    type: actionTypes.EDIT_PRODUCT_SUCCESS,
    addProductRes,
  };
};

const editProductFailed = (error: any) => {
  return {
    type: actionTypes.EDIT_PRODUCT_FAIL,
    error,
    addProductRes: null,
  };
};

export const editProduct = (data: any) => {
  return async (dispatch: any) => {
    dispatch(editProductStart());

    return axios
      .post(`/seller/advert/edit`, data)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          return dispatch(editProductSuccess(data.data));
        }
      })
      .catch((err) => dispatch(editProductFailed(getErrors(err))));
  };
};

// More Products from seller
const getMoreProductFromSellerStart = () => {
  return {
    type: actionTypes.GET_MORE_PRODUCT_FROM_SELLER_START,
  };
};

const getMoreProductFromSellerSuccess = (products: any) => {
  return {
    type: actionTypes.GET_MORE_PRODUCT_FROM_SELLER_SUCCESS,
    products,
  };
};

const getMoreProductFromSellerFailed = (error: any) => {
  return {
    type: actionTypes.GET_MORE_PRODUCT_FROM_SELLER_FAIL,
    error,
    addProductRes: null,
  };
};

export const getMoreProductFromSeller = (data: any, profile:any) => {
  const URL =`${profile?.profileType ? profile?.profileType?.toLocaleLowerCase(): ''}/adverts`;

  return async (dispatch: any) => {
    dispatch(getMoreProductFromSellerStart());

    return axios
      .post(URL, data)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          return dispatch(getMoreProductFromSellerSuccess(data.data));
        }
      })
      .catch((err) => dispatch(getMoreProductFromSellerFailed(getErrors(err))));
  };
};

//Control deleted Images 
export const addToDeletedImages = (data: any) => {
  return {
    type: actionTypes.ADD_TO_DELETED_IMAGES,
    data: data,
  }
}

export const clearDeletedImages = () => {
  return {
    type: actionTypes.CLEAR_DELETED_IMAGES,
  }
}

// control uploaded Images 
export const updateUploadedImages = (data: any) => {
  return {
    type: actionTypes.ADD_TO_UPLOADED_IMAGES,
    data: data,
  }
}

export const clearUploadedImages = () => {
  return {
     type: actionTypes.CLEAR_UPLOADED_IMAGES,
  };
}; 

// Get advert Images using Advert Id
const getImageFromAdvertIdStart = () => {
  return {
    type: actionTypes.GET_IMAGE_FROM_ADVERTID_START,
  };
};

export const getImageFromAdvertIdSuccess = (productImageAdvertId: any) => {
    return {
      type: actionTypes.GET_IMAGE_FROM_ADVERTID_SUCCESS,
      productImageAdvertId
    };
};

const getImageFromAdvertIdFailed = (error: any) => {
  return {
    type: actionTypes.GET_IMAGE_FROM_ADVERTID_FAIL,
    error,
  };
};

export const getImageFromAdvertId = (advertId: number) => {
  const URL =`/advert/image/main/load/${advertId}`;

  return (dispatch: any) => {
    dispatch(getImageFromAdvertIdStart());

    return axios
      .get(URL)
      .then((response) => {
        if (!response) throw new Error("No Response");
        
        let data;
        if(response.data.data){
          data = formatBase64Image(response.data.data);        
        }
        return dispatch(getImageFromAdvertIdSuccess({data, advertId}));
      })
      .catch((err) => dispatch(getImageFromAdvertIdFailed(getErrors(err))));
  };
};

// republish Product
export const republishProductStart = () => {
  return {
    type: actionTypes.REPUBLISH_PRODUCT_START,
  };
};

export const republishProductSuccess = () => {
  return {
    type: actionTypes.REPUBLISH_PRODUCT_SUCCESS,
  };
};

export const republishProductFailed = (error: any) => {
  return {
    type: actionTypes.REPUBLISH_PRODUCT_FAIL,
    error,
  };
};

export const republishProduct = (data: any) => {
  return async (dispatch: any) => {
    dispatch(republishProductStart());

    return axios
      .post(`/seller/advert/republish`, data)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          return dispatch(republishProductSuccess());
        }
      })
      .catch((err) => dispatch(republishProductFailed(getErrors(err))));
  };
};

// Get Product feedbacks By Advert ID
export const getProductFeedbacksStart = () => {
  return {
    type: actionTypes.GET_PRODUCT_FEEDBACKS_START,
  };
};

export const getProductFeedbacksSuccess = (productFeedbacks: any) => {
  return {
    type: actionTypes.GET_PRODUCT_FEEDBACKS_SUCCESS,
    productFeedbacks,
  };
};

export const getProductFeedbacksFailed = (error: any) => {
  return {
    type: actionTypes.GET_PRODUCT_FEEDBACKS_FAIL,
    error,
  };
};

export const getProductFeedbacks = (data: any) => {
  return async (dispatch: any) => {
    dispatch(getProductFeedbacksStart());

    return axios
      .post(`/buyer/feedbacks`, data)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          dispatch(getProductFeedbacksSuccess(data.data));
        }
      })
      .catch((err) => dispatch(getProductFeedbacksFailed(getErrors(err))));
  };
};

// Get Product feedback Summary By Advert ID
export const getProductFeedbackSummaryStart = () => {
  return {
    type: actionTypes.GET_PRODUCT_FEEDBACK_SUMMARY_START,
  };
};

export const getProductFeedbackSummarySuccess = (ProductFeedbackSummary: any) => {
  return {
    type: actionTypes.GET_PRODUCT_FEEDBACK_SUMMARY_SUCCESS,
    ProductFeedbackSummary,
  };
};

export const getProductFeedbackSummaryFailed = (error: any) => {
  return {
    type: actionTypes.GET_PRODUCT_FEEDBACK_SUMMARY_FAIL,
    error,
  };
};

export const getProductFeedbackSummary = (advertId: any) => {
  return async (dispatch: any) => {
    if(!advertId){
      return;
    }

    dispatch(getProductFeedbackSummaryStart());

    return axios
      .get(`/buyer/feedback/summary/${advertId}`)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));

          let feedbackSummary = {
            data: {},
            total: 0,
            averageRating: 0 as any,
          };

          let totalRating: number = 0;

          data?.data?.forEach((item: any, i: number) => {
            // @ts-ignore
            feedbackSummary.data[item?.rate || 0] = item;

            feedbackSummary.total = feedbackSummary.total +  (item?.count || 0);

            totalRating = totalRating + (item?.rate * item?.count);
          });

          feedbackSummary.averageRating = (totalRating / feedbackSummary.total) || 0;

          if(feedbackSummary.averageRating.toString().includes(".")){
            feedbackSummary.averageRating = feedbackSummary.averageRating?.toFixed(1);
          }

          dispatch(getProductFeedbackSummarySuccess(feedbackSummary));
        }
      })
      .catch((err) => dispatch(getProductFeedbackSummaryFailed(getErrors(err))));
  };
};

// Add Review
export const addReviewStart = () => {
  return {
    type: actionTypes.ADD_REVIEW_START,
  };
};

export const addReviewSuccess = () => {
  return {
    type: actionTypes.ADD_REVIEW_SUCCESS,
  };
};

export const addReviewFailed = (error: any) => {
  return {
    type: actionTypes.ADD_REVIEW_FAIL,
    error,
  };
};

export const addReview = (data: any) => {
  return async (dispatch: any) => {
    dispatch(addReviewStart());

    return axios
      .post(`/buyer/feedback/submit`, data)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          return dispatch(addReviewSuccess());
        }
      })
      .catch((err) => dispatch(addReviewFailed(getErrors(err))));
  };
};